module.exports = __webpack_public_path__ + "media/images/application/template/insta-77cd17fdb3585355c73f04038789854c.svg";